export default "__VITE_ASSET__m7f7uaIn__"